import {normalizeError} from "./error";
//import history from '../../libs/history';
import {toast} from "react-toastify";
//import {TYPES as FORUM_TOPIC_TYPE} from '../../creators/forums.topic';
//import {matchPath} from "react-router-dom";


let statusCodeMapping = {
    // 409 : 'Conflit, une entrée similaire existe déjà',
    // 400 : 'Certains champs sont invalides',
    // 400 : 'Une erreur est survenue, essayez de rafraîchir la page',
    401 : 'Identifiants incorrects',
    // 403 : 'Vous n\'êtes pas autorisé à executer cette action',
    415 : 'Type de fichier non supporté',
    413 : 'Fichier trop lourd',
    429 : `Trop d'actions dans un court laps de temps, veuillez patienter avant de recommencer.`,
    500 : 'Une erreur serveur est survenue, c  ontactez un administrateur ou un membre de l\'équipe technique',
    501 : 'Cette fonctionnalité n\'est pas disponible'
};
/*
const reduxActionTo404Map = {
    [FORUM_TOPIC_TYPE.GET_ONE] : {
        state : {
            message : "Toto"
        },
        page : '/forum-sexe/'
    }
};*/

export default {
    response: {
        success: ({getState, dispatch, getSourceAction}, response) => {
            return response.data;
        },
        error: ({getState, dispatch, getSourceAction}, error) => {
            let errorResponse = error.response || {};
            let responseData = errorResponse.data || {};
            let normalized = normalizeError({
                errors: responseData.errors,
                message: responseData.message || errorResponse.statusText,
                name: null,
                statusCode: responseData.statusCode || errorResponse.status,
                error: responseData.error || errorResponse.statusText,
            });
            if(statusCodeMapping[normalized.statusCode]){
                toast(statusCodeMapping[normalized.statusCode],{
                    autoClose: 10000,
                    className: 'toast-background toast-error',
                    bodyClassName: "toast-font toast-error",
                    progressClassName: 'toast-loader toast-error'
                });
            }

            if(normalized.statusCode === 404){
                /*let {type = "", payload = {}} = getSourceAction(error.config);

                let reduxActionTo404 = reduxActionTo404Map[type];
                if(reduxActionTo404){
                    console.log("OKKKK", reduxActionTo404, history.location.pathname, matchPath(history.location.pathname, {
                        path: "/forum-sex/:slugParent([A-Za-z0-9_-]+)?/:slug([A-Za-z0-9_-]+)/:topicSlug([A-Za-z0-9_-]+)_:topicId/:page([0-9]+)?",
                    }));
                }*/
                // history.push('/404');
            }
            return Promise.reject({...error, response: normalized});
        }
    }
};